module.exports = __webpack_public_path__ + "static/media/rune-filter.97ef2620.png";